import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular'; 
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-add-shipping',
  templateUrl: './add-shipping.component.html',
  styleUrls: ['./add-shipping.component.scss']
})
export class AddShippingComponent implements OnInit {
  // step = 0;
  @Input() step: any = 0;
  @Input() shippingAddress: any;
  @Input() selectedLocation: any;
  @Input() cart: any;
  @Input() stitchFields: any;

  constructor(private SS: SubjectService, private modalController: ModalController,    
     private GAS: GoogleAnalyticsService,
    ) { }

  ngOnInit() {
    this.SS.nextStep.subscribe(index=>{
      if(index > 0){
        this.step = index;
      }
    });

    this.SS.previousStep.subscribe(index=>{
      if(index == 0){  
        this.step = 0;
      }
    });
  }

  dismiss(){
    if (this.cart?.items?.length > 0) {
      this.GAS.checkoutOptimizationTracking('search_location', this.cart?.items, this.cart, '', 'close', 'checkout');
    }
    this.modalController.dismiss({dismissed:true});
  }

}
